!function e(t,r,n){function o(u,c){if(!r[u]){if(!t[u]){var s="function"==typeof require&&require;if(!c&&s)return s(u,!0);if(i)return i(u,!0);var f=new Error("Cannot find module '"+u+"'");throw f.code="MODULE_NOT_FOUND",f}var a=r[u]={exports:{}};t[u][0].call(a.exports,(function(e){return o(t[u][1][e]||e)}),a,a.exports,e,t,r,n)}return r[u].exports}for(var i="function"==typeof require&&require,u=0;u<n.length;u++)o(n[u]);return o}({1:[function(e,t,r){"use strict";let n=e("./"),o=e("./manager");window.CookieProxy=o,n()},{"./":2,"./manager":3}],2:[function(e,t,r){"use strict";let n=Object.getOwnPropertyDescriptor(HTMLDocument.prototype,"cookie")||Object.getOwnPropertyDescriptor(Document.prototype,"cookie"),o=e("./proxy"),i=e("./shim");t.exports=function(e){let t=o(n);i(t)}},{"./proxy":5,"./shim":6}],3:[function(e,t,r){"use strict";let n=function(e){};function o(e){n=e}function i(){return n}t.exports={setFilter:o,getFilter:i}},{}],4:[function(e,t,r){"use strict";function n(e){return e.split(";").map((function(e){return e.trim().split("=").map(decodeURIComponent)}))}t.exports={parseCookies:function(e){return n(e).reduce((function(e,t){try{e[t.name]=JSON.parse(t.value)}catch(r){e[t.name]=t.value}return e}),{})},parse:function(e){return n(e).reduce((function(e,t){if(!e.name){e.name=t[0];try{e.value=JSON.parse(t[1])}catch(r){e.value=t[1]}return e}try{e[t[0]]=JSON.parse(t[1])}catch(r){e[t[0]]=t[1]}return e}),{})}}},{}],5:[function(e,t,r){"use strict";let n=e("./parser"),o=e("./manager");t.exports=function(e){return function(){let t={subject:e,set:function(e){o.getFilter()(n.parse(e))&&(document.cookieProxy=e)},get:function(){return document.cookieProxy}};return document.__defineGetter__("cookieProxy",e.get),document.__defineSetter__("cookieProxy",e.set),t}.bind(document)()}},{"./manager":3,"./parser":4}],6:[function(e,t,r){"use strict";t.exports=function(e){e.__defineGetter__("cookie",e.subject.get),e.__defineSetter__("cookie",e.subject.set),Object.defineProperty(document,"cookie",e)}},{}]},{},[1]);

// Cookies control settings and preferences
window.loadedCookies = [];
window.staticalCookies = ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', '_hjTLDTest', '_hjid', '_hjFirstSeen', '_hjIncludedInPageviewSample', '_hjAbsoluteSessionInProgress'];
window.marketingCookies = ['DSID', 'IDE', 'NID', '__Secure-3PSIDCC', '__Secure-3PSID']
window.allowedStaticalCookies = getCookie('allow_statical');
window.allowedMarketingCookies = getCookie('allow_marketing');
window.showedSettings = getCookie('showed_settings');

// Load only allowed cookies
CookieProxy.setFilter(function(cookie) {
    loadedCookies.push(cookie);

    if (window.allowedStaticalCookies == 1 && window.staticalCookies.indexOf(cookie.name) >= 0) {
        return  true;
    } else if (window.allowedMarketingCookies == 1 && window.marketingCookies.indexOf(cookie.name) >= 0) {
        return  true;
    } else {
        return false;
    }
});


function enableCookiesProxy() {
    CookieProxy.setFilter(function(cookie) {
        return  true;
    });
}

function getCookie(cname) {
    var name = cname + "=",
        decodedCookie = decodeURIComponent(document.cookie),
        ca = decodedCookie.split(';');

    for (var i = 0; i <ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return false;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();

    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function addStaticalCookies() {
    enableCookiesProxy();

    setCookie('allow_statical', 1, 365);

    window.loadedCookies.forEach(function (cookie) {

        if (window.staticalCookies.indexOf(cookie.name) >= 0) {
            document.cookie = cookie.name + '=' + cookie.value +  '; expires=' + cookie.expires + '; domain=' + cookie.domain +'; path=' + cookie.path + ';';
        }
    })
}

function showSettingsCookies() {
    enableCookiesProxy();

    setCookie('showed_settings', 1, 365);
}

function addMarketingCookies() {
    enableCookiesProxy();

    setCookie('allow_marketing', 1, 365);

    window.loadedCookies.forEach( function (cookie) {

        if (window.marketingCookies.indexOf(cookie.name) >= 0) {
            document.cookie = cookie.name + '=' + cookie.value +  '; expires=' + cookie.expires + '; domain=' + cookie.domain +'; path=' + cookie.path + ';';
        }
    })
}

function deleteCookie(cname) {
    document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function removeStaticalCookies() {
    enableCookiesProxy();

    deleteCookie('allow_statical');

    window.loadedCookies.forEach(function (cookie) {

        if (window.staticalCookies.indexOf(cookie.name) >= 0) {
            document.cookie = cookie.name + '=' + cookie.value +  '; expires=' + cookie.expires + '; domain=' + cookie.domain +'; path=' + cookie.path + ';';
        }
    })
}

function removeMarketingCookies() {
    enableCookiesProxy();

    // First delete statical_cookies
    deleteCookie('allow_marketing');

    window.loadedCookies.forEach(function (cookie) {

        if (window.marketingCookies.indexOf(cookie.name) >= 0) {
            document.cookie = cookie.name + '=' + cookie.value +  '; expires=' + cookie.expires + '; domain=' + cookie.domain +'; path=' + cookie.path + ';';
        }
    })
}

$(document).ready(function() {
    const urlParams = new URLSearchParams(window.location.search)
    const isHideCookies = urlParams.get('hide-cookies')

    if (isHideCookies) {
        console.log(isHideCookies)
        return
    }

    $('.js_acceptCookies').click(function (e) {
        e.preventDefault();
        addMarketingCookies();
        addStaticalCookies();
        $('#allow_statical').attr("checked", true);
        $('#allow_statical').next('span').text('On');
        $('#allow_marketing').attr("checked", true);
        $('#allow_marketing').next('span').text('On');
        $('body').addClass('hasCookies');
        $('.cookiesFooter').fadeOut();
    })

    $('.js_cookiesSettings').click(function() {
        $('.cookiesFooter').fadeOut();
        $('#cookiesSettings').fadeIn();
    });

    $('#allow_marketing').change(function() {

        if (this.checked) {
            $(this).attr("checked", true);
            $(this).next('span').text('On');

        } else {
            $(this).removeAttr("checked");
            $(this).next('span').text('Off');
        }
    });


    $('#allow_statical').change(function() {

        if (this.checked) {
            $(this).attr("checked", true);
            $(this).next('span').text('On');
        } else {
            $(this).removeAttr("checked");
            $(this).next('span').text('Off');
        }
    });

    $('.js_saveCookies').click(function(e) {
        e.preventDefault();

        if ($('#allow_marketing').is(':checked')) {
            addMarketingCookies();
        } else {
            removeMarketingCookies();
        }

        if ($('#allow_statical').is(':checked')) {
            addStaticalCookies();
        } else {
            removeStaticalCookies();
        }

        $(this).closest("#cookiesSettings").fadeOut();
    })

    $('.js_closeCookies, #cookiesSettings .overlay').click(function(e) {
        e.preventDefault();
        $(this).closest("#cookiesSettings").fadeOut();
        $('body').addClass('hasCookies');
    });

    if (window.allowedStaticalCookies || window.allowedMarketingCookies) {
        $('body').addClass('hasCookies');
    } else {
        $('body').removeClass('hasCookies');
        $('.cookiesFooter').fadeIn();
    }
});
